<template>
 <div>
  <RecordNotFound
      v-if="status_code == 404"
      :message="status_message"
    ></RecordNotFound>
  <div v-else-if="is_no_records == 1">
    <GlobalEmptyRecord RouteName="SalesCreate">
      <template slot="title">
        <h2>Deal of the Day!!</h2>
      </template>
      <template slot="content">
        <span style="color:gray">Create Deals better than the Best</span>
      </template>
      <template slot="page" @click="changecode()">New Quotation</template>
    </GlobalEmptyRecord>
  </div>
  <div class="start-page" v-else style="margin-top:-10px !important">
    <!-- section 1: theader row to declare page headign and to call create page button -->

    <template v-if="CheckedCount == 0 ">
      <b-row class="px-pad border-bottom" style="height:42px">
        <b-col cols="6" class="px-0">
          <b-dropdown
            variant="link"
            class="index-filter-heading"
            size="sm"
            dropdown
            toggle-class="text-decoration-none"
            :text="filter_name"
          >
            <div class="dropdownitem-list">
              <b-dropdown-item
                :class="{'filter_dropdown' : true}"
                :to="{ name : 'Sales',query: {page: 1 ,show: 10,search:'',from_date:from_date,to_date:to_date,sort:sort,label:label,status:item.status_id,custom:custom } }"
                v-for="item in filter_list"
                :key="item.status_id"
                v-if="item.status_name != filter_name"
              >{{ item.status_name }}</b-dropdown-item>
            </div>

            <b-dropdown-divider />
            <router-link
              class="event-link dropdown-item"
              :to="{ name : 'FilterCreate',params : {title :'Sales',module:'sales',call:'fetchSalesDetails',type:'quotation',route:'quotation'}}"
            >Add Custom Filter</router-link>
          </b-dropdown>
          <!-- filter edit option -->
          <router-link
            class="event-link"
            v-if="status >= 100"
            :to="{ name : 'FilterUpdate',params : {id:getPresentValue(filter_list,'status_name',filter_name),title :'Sales',type:'quotation',module:'sales',call:'fetchSalesDetails',route:'quotation'}}"
          >
            <b-button size="xs" style="position:relative;bottom:4px;" variant="light">
              <i class="la la-edit la-lg"></i>
            </b-button>
          </router-link>
          <!-- <span class="fw-semi-bold ml-3">For period :</span> -->
          <span
            style="cursor:pointer"
            class="text-link text-underline"
            @click="getDateRange({})"
            v-if="$route.query.from_date && $route.query.to_date"
          >
            <u>Remove Date filter</u>
          </span>
        </b-col>
        <b-col cols="6" class="text-right px-0">
          <router-link
            :to="{ name : 'SalesCreate'}"
            v-if="RoutePermission(false,'','invoice','quotation','create')"
          >
            <b-button variant="primary" size="sm" class="mr-2" @click="changecode()">New Quotation</b-button>
          </router-link>
          <b-button variant="light" size="sm" class="mr-2" @click="getrefreshList()">
            <i class="la la-refresh la-lg"></i>
          </b-button>
          <b-dropdown variant="light" size="sm" class="no-caret-dropdown">
            <template slot="button-content">
              <i class="la la-navicon la-lg"></i>
            </template>
            <template v-if="RoutePermission(false,'','','settings','export')">
              <b-dropdown-item @click="exportModal()">
                <span class="no_caret_import la la-download mr-3"></span>Export Quotation
              </b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
            </template>
            <p class="fw-semi-bold theme-text-color ml-3">Add Columns</p>
            <div class="dropdownitem-block">
              <li class="ml-3">
                <b-form-checkbox
                  name="sales_person_name"
                  v-model="sales_person_name"
                  value="1"
                >Sales Person</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox name="ref_no" v-model="ref_no" value="1">Reference No</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox name="total_qty" v-model="total_qty" value="7">Total Quantity</b-form-checkbox>
              </li>

              <li class="ml-3 pt-2">
                <b-form-checkbox
                  name="place_of_supply"
                  v-model="place_of_supply"
                  value="2"
                >Place of Supply</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox
                  name="quot_expiry_date"
                  v-model="quot_expiry_date"
                  value="3"
                >Expiry Date</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox
                  name="total_without_tax"
                  v-model="total_without_tax"
                  value="4"
                >Total without Tax</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox name="total_tax" v-model="total_tax" value="5">Total Tax</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox
                  name="adjusted_amount"
                  v-model="adjusted_amount"
                  value="6"
                >Adjusted Amount</b-form-checkbox>
              </li>

              <li class="ml-3 pt-2">
                <b-form-checkbox
                  name="total_discount"
                  v-model="total_discount"
                  value="8"
                >Total Discount Amount</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox name="created_at" v-model="created_at" value="9">Created Time</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2 pb-2">
                <b-form-checkbox name="updated_at" v-model="updated_at" value="10">Updated Time</b-form-checkbox>
              </li>
            </div>
          </b-dropdown>
          <GlobalDateRangePicker
            class="ml-2 date_range_pick"
            :singleDatePicker="false"
            :class="{'ml-2': true}"
            ref="daterangeupdate"
            v-on:setDateRange="getDateRange($event)"
            :fromDate="from_date"
            :toDate="to_date"
          />
        </b-col>
      </b-row>
    </template>
    <!-- section 2: to show the search criteria detail  -->
    <b-row>
      <b-col cols="12" class="px-0">
        <b-row style="height:42px" class="px-pad border-bottom" v-if="CheckedCount > 0">
          <b-col xl="6" lg="6" md="6" sm="6" xs="6" cols="6" class="test">
            <!--  delete the selected invoice -->
            <b-button
              size="sm"
              variant="light"
              class="text-left"
              @click="deletemodal"
              :disabled="!RoutePermission(false,'','invoice','quotation','delete')"
            >
              <i
                class="glyphicon glyphicon-trash"
                v-b-tooltip="!RoutePermission(false,'','invoice','quotation','delete')?' You do not have permission to perform this operation. Please contact your Administrator. ':''"
              ></i>
            </b-button>
          </b-col>
          <b-col xl="6" lg="6" md="6" sm="6" xs="6" cols="6">
            <i
              v-on:click="checkAll({
              target :{
                checked : false
              }
            }),CheckedCount = 0,checkboxes1[0] = false"
              class="la la-times-circle-o la-lg cursor_pointer float-right mar-top-close"
            ></i>
          </b-col>
        </b-row>
        <b-alert
          class="alert-transparent alert-shade mx-mar mt-3"
          :show="this.$route.params.search == '' ? false : true"
        >
          <router-link
            class="text-dark float-right"
            :to="{ name : 'Sales',query: {page: page ,show: count,search:'',from_date:from_date,to_date:to_date,sort:sort,label:label,custom:custom } }"
          >
            <i class="la la-remove la-lg text-decoration-none"></i>
          </router-link>
          <p>
            <span class="fw-semi-bold">Quotation No / Customer Name / Customer ID / Number:</span>
            {{ this.$route.query.search }}
          </p>
        </b-alert>
        <!--  section 4:show the list of table data form api -->
        <div
          :class="this.$route.params.search=='' ?'table-responsive':'table_search'"
          id="scrollCol"
        >
          <table class="table table-hover index-table">
            <thead>
              <tr>
                <th style="width:54px !important">
                  <div class="abc-checkbox index-checkbox text-left">
                    <input
                      type="checkbox"
                      id="checkboxall"
                      v-model="checkboxes1[0]"
                      @change="event => checkAll(event)"
                    />
                    <label for="checkboxall" />
                  </div>
                </th>
                <th style="min-width:85px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'Sales',query: {page: page,show: show,search:search_criteria,from_date:from_date,to_date:to_date,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'quot_no',custom:custom } }"
                  >
                    ID
                    <small class="text-muted" v-if="label == 'quot_no'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="min-width:200px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'Sales',query: {page: page,show: show,search:search_criteria,from_date:from_date,to_date:to_date,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'cus_name',custom:custom } }"
                  >
                    Customer
                    <small class="text-muted" v-if="label == 'cus_name'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="min-width:180px !important" v-if="sales_person_name==1">Sales Person</th>
                <th style="min-width:200px !important" v-if="place_of_supply==2">Place of supply</th>
                <th style="min-width:140px !important" v-if="total_qty==7">Quantity</th>
                <th style="min-width:135px !important" v-if="ref_no==1">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'Sales',query: {page: page,show: show,search:search_criteria,from_date:from_date,to_date:to_date,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'ref_no',custom:custom } }"
                  >
                    Ref No.
                    <small class="text-muted" v-if="label == 'ref_no'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>

                <th style="min-width:140px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'Sales',query: {page: page,show: show,search:search_criteria,from_date:from_date,to_date:to_date,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'quot_created_date',custom:custom } }"
                  >
                    Quotation Date
                    <small class="text-muted" v-if="label == 'quot_created_date'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="min-width:140px !important" v-if="quot_expiry_date==3">Expiry Date</th>
                <th style="min-width:110px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'Sales',query: {page: page,show: show,search:search_criteria,from_date:from_date,to_date:to_date,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'quot_status_name',custom:custom } }"
                  >
                    Status
                    <small class="text-muted" v-if="label == 'quot_status_name'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>

                <th
                  style="min-width:140px !important"
                  class="text-right"
                  v-if="total_without_tax==4"
                >Without Tax</th>
                <th style="min-width:140px !important" class="text-right" v-if="total_tax==5">Tax</th>
                <th
                  style="min-width:140px !important"
                  class="text-right"
                  v-if="adjusted_amount==6"
                >Adjusted Amt.</th>

                <th
                  style="min-width:140px !important"
                  class="text-right"
                  v-if="total_discount==8"
                >Discount Amt.</th>
                <th style="min-width:140px !important" class="text-right">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'Sales',query: {page: page,show: show,search:search_criteria,from_date:from_date,to_date:to_date,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'total_value',custom:custom } }"
                  >
                    Total Price
                    <small class="text-muted" v-if="label == 'total_value'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="min-width:300px !important" v-if="created_at">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{
                      name: 'Sales',
                      query: {
                        page: page,
                        show: show,
                        search: search_criteria,
                        from_date: from_date,
                        to_date: to_date,
                        status: status,
                        sort: sort == 'asc' ? 'desc' : 'asc',
                        label: 'created_at',
                        custom: custom,
                      },
                    }"
                  >
                    Created Time
                    <small class="text-muted" v-if="label == 'created_at'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="min-width:300px !important" v-if="updated_at">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{
                      name: 'Sales',
                      query: {
                        page: page,
                        show: show,
                        search: search_criteria,
                        from_date: from_date,
                        to_date: to_date,
                        status: status,
                        sort: sort == 'asc' ? 'desc' : 'asc',
                        label: 'updated_at',
                        custom: custom,
                      },
                    }"
                  >
                    Updated Time
                    <small class="text-muted" v-if="label == 'updated_at'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th class="text-right" style="width:30px !important"></th>
              </tr>
            </thead>
            <tbody v-if="loading == true">
              <template v-if="lists.length == 0">
                <tr>
                  <td colspan="8" class="text-center">No data to display</td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="(list,index) in lists" :key="list.quot_hdr_id">
                  <td>
                    <div class="abc-checkbox index-checkbox text-left">
                      <input
                        type="checkbox"
                        v-model="checkboxes1[index + 1]"
                        :id="'checkbox'+(index+1)"
                        :true-value="list.quot_hdr_id"
                        :value="list.quot_hdr_id"
                        @change="event => changeCheck(event, 'checkboxes1', index+1)"
                      />
                      <label :for="'checkbox'+(index+1)" />
                    </div>
                  </td>
                  <td
                    v-if="RoutePermission(false,'','invoice','quotation','index')"
                    class="text-nowrap"
                  >
                    <router-link
                      class="theme-text-color"
                      :to="{ name : 'SalesView',params:{id:list.quot_hdr_id}}"
                    >{{ list.quot_no }}</router-link>
                  </td>
                  <td v-else class="theme-text-color text-nowrap">{{ list.quot_no }}</td>
                  <td style="max-width:200px !important">
                    <span class="text">{{ list.cus_name }}</span>
                  </td>
                  <td style="width:180px !important" v-if="sales_person_name==1">
                    <span class="text">{{list.sales_person_name}}</span>
                  </td>
                  <td
                    v-if="place_of_supply==2"
                  >{{ getDetails($AppDetails.state_details,list.place_of_supply,'state_name')}}</td>
                  <td
                    v-if="total_qty==7"
                  >{{parseFloat(list.total_qty).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 })}}</td>
                  <td v-if="ref_no==1">{{ list.ref_no }}</td>

                  <td
                    v-if="
                    ((RoutePermission(false, '', 'invoice', 'quotation', 'update') &&  list.quot_status < 2  ) || (RoutePermission(false, '', 'invoice', 'quotation', 'approvedaccess') &&  list.quot_status >= 2  )) && list.quot_status !='5' "
                  >
                    <router-link
                      class="text-dark event-link"
                      :to="{ name : 'SalesUpdate',params:{id:list.quot_hdr_id}}"
                    >{{ getDateFormat(list.quot_created_date) }}</router-link>
                  </td>

                  <td v-else>{{ getDateFormat(list.quot_created_date) }}</td>
                  <td v-if="quot_expiry_date==3">{{getDateFormat(list.quot_expiry_date)}}</td>
                  <td class>{{ list.quot_status_name }}</td>

                  <td class="text-right" v-if="total_without_tax==4">
                    {{ getDetails(
                    $AppDetails.currency_details,
                    list.cus_currency,
                    "currency_symbol"
                    )+" "+parseFloat(list.total_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </td>
                  <td class="text-right" v-if="total_tax==5">
                    {{getDetails(
                    $AppDetails.currency_details,
                    list.cus_currency,
                    "currency_symbol"
                    )+" "+ parseFloat(list.total_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </td>
                  <td class="text-right" v-if="adjusted_amount==6">
                    {{ getDetails(
                    $AppDetails.currency_details,
                    list.cus_currency,
                    "currency_symbol"
                    )+" "+parseFloat(list.adjusted_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </td>

                  <td class="text-right" v-if="total_discount==8">
                    {{ getDetails(
                    $AppDetails.currency_details,
                    list.cus_currency,
                    "currency_symbol"
                    )+" "+parseFloat(list.total_discount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </td>
                  <td class="text-right">
                    {{ getDetails(
                    $AppDetails.currency_details,
                    list.cus_currency,
                    "currency_symbol"
                    )+" "+parseFloat(list.total_value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </td>
                  <td v-if="created_at">{{ displayDateTime(list.created_at) }}</td>
                  <td v-if="updated_at">{{ displayDateTime(list.updated_at) }}</td>
                  <td class="text-right" style="width:30px !important">
                    <b-dropdown
                      right
                      toggle-class="text-decoration-none"
                      variant="link"
                      no-caret
                      size="xs"
                      class="table-hover-visible last-td-arrow"
                      v-if="(list.quot_status!='5'&&((RoutePermission(false, '', 'invoice', 'quotation', 'update') &&  list.quot_status < 2  ) || (RoutePermission(false, '', 'invoice', 'quotation', 'approvedaccess') &&  list.quot_status >= 2  )))||RoutePermission(false,'','invoice','quotation','create')"
                    >
                      <template slot="button-content">
                        <i
                          class="glyphicon glyphicon-option-vertical theme-text-color"
                          style="top:-6px !important;letter-spacing:-5px !important"
                        ></i>
                      </template>
                      <router-link
                        v-if="
                    ((RoutePermission(false, '', 'invoice', 'quotation', 'update') &&  list.quot_status < 2  ) || (RoutePermission(false, '', 'invoice', 'quotation', 'approvedaccess') &&  list.quot_status >= 2  )) && list.quot_status !='5' "
                        class="event-link dropdown-item"
                        :to="{ name : 'SalesUpdate',params:{id:list.quot_hdr_id}}"
                      >Edit</router-link>
                      <router-link
                        v-if="RoutePermission(false,'','invoice','quotation','create')"
                        class="event-link dropdown-item"
                        :to="{ name : 'SalesCreate',query:{clone_id:list.quot_hdr_id}}"
                      >Clone</router-link>
                      <!-- <template v-if="list.quot_status != 3">
                        <a
                          @click="changeStatus(status.quot_status_id,list.quot_hdr_id)"
                          class="dropdown-item"
                          role="menuitem"
                          v-if="status.quot_status_id != list.quot_status && RoutePermission(false,'','invoice','quotation','update')"
                          v-for="status in quot_status"
                          :key="status.quot_status_id"
                        >{{ status.quot_status_name }}</a>
                      </template>-->
                    </b-dropdown>
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>Loading...</tr>
            </tbody>
          </table>
        </div>
      </b-col>
    </b-row>
    <!--  section 5:pagination detail of the table -->
    <b-row
      v-if="lists.length > 0"
      style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
      class="px-pad"
    >
      <b-col xl="5" md="6" lg="6" sm="8" class="mt-2 pt-1 px-0">
        <nav class="float-left">
          <p>
            Showing {{ (total_count != 0 ) ? ((page - 1) * count) + 1 : 0 }} to {{ ((page - 1) * show) + lists.length }}
            of {{ total_count }} entries
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                size="xs"
                :text="count"
                left
              >
                <router-link
                  :to="{ name : 'Sales',query: {page: 1,show: 10,search:search_criteria,status:status,from_date:from_date,to_date:to_date,sort:sort,label:label,custom:custom } }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'Sales',query: {page: 1,show: 25,search:search_criteria,status:status,from_date:from_date,to_date:to_date,sort:sort,label:label,custom:custom } }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'Sales',query: {page: 1 ,show: 50,search:search_criteria,status:status,from_date:from_date,to_date:to_date,sort:sort,label:label,custom:custom } }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                </router-link>
              </b-dropdown>
            </span> rows per page
          </p>
        </nav>
      </b-col>
      <b-col xl="2" md="2" lg="2" sm="4" style="text-align: center;" class="mt-2 pt-1 px-0">
        <div v-if="arrow">
          <a @click="left('#scrollCol')" class="mr-2">
            <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
          </a>
          <a @click="right('#scrollCol')">
            <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
          </a>
        </div>
      </b-col>
      <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
        <template v-if="total_count > show">
          <nav class="float-right">
            <ul class="pagination">
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'Sales',query: {page: page - 1 ,show: count,search:search_criteria,status:status,from_date:from_date,to_date:to_date,sort:sort,label:label,custom:custom } }"
                  >
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'Sales',query: {page: 1 ,show: count,search:search_criteria,status:status,from_date:from_date,to_date:to_date,sort:sort,label:label,custom:custom } }"
                >First</router-link>
              </li>
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'Sales',query: {page: page - 1 ,show: count,search:search_criteria,status:status,from_date:from_date,to_date:to_date,sort:sort,label:label,custom:custom } }"
                  >Previous</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Previous</a>
                </template>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'Sales',query: {page: page + 1,show: count,search:search_criteria,status:status,from_date:from_date,to_date:to_date,sort:sort,label:label,custom:custom  } }"
                  >Next</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Next</a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'Sales',query: {page: Math.ceil(total_count / count),show: count,search:search_criteria,status:status,from_date:from_date,to_date:to_date,sort:sort,label:label,custom:custom  } }"
                >Last</router-link>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'Sales',query: {page: page + 1,show: count,search:search_criteria,status:status,from_date:from_date,to_date:to_date,sort:sort,label:label,custom:custom  } }"
                  >
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </template>
              </li>
            </ul>
          </nav>
        </template>
      </b-col>
    </b-row>
    <!--  section 5:modal confirmation popup for email api -->
    <b-modal
      id="email"
      size="sm"
      body-class="bg-white"
      cancel-title="close"
      cancel-variant="light"
      ok-title="Send"
      title="Send Email"
      @ok="handleEmail"
    >
      <p>Are you sure about email this Quotation ?</p>
    </b-modal>
    <b-modal
      id="salesdelete"
      size="sm"
      body-class="bg-white"
      cancel-title="Cancel"
      cancel-variant="light"
      ok-title="Yes"
      title="Bulk Delete-Quotations"
    >
      <p>Are you sure about deleting the selected quotation(s)?</p>
    </b-modal>
    <b-modal
      id="salesupdate"
      size="md"
      body-class="bg-white"
      cancel-title="Cancel"
      cancel-variant="light"
      ok-title="Update"
      title="Bulk Update-Quotations"
    >
      <p>Choose a field from the dropdown and update with new information.</p>
      <b-row>
        <b-col>
          <b-form-group>
            <select
              name="update"
              class="form-control text-right"
              style="padding:2px;background: #f7f7f7;"
              placeholder="Select a field"
            >
              <option value="0"></option>
              <option value="1">Reference</option>
              <option value="1">PDF template</option>
              <option value="2">Estimate Date</option>
              <option value="4">Expiry date</option>
              <option value="4">Payment Terms</option>

              <option value="3">Customer Notes</option>
              <option value="4">Terms and conditions</option>
            </select>
          </b-form-group>
        </b-col>
        <b-col style="max-width:500px">
          <b-form-input type="text" size="sm" name="type" />
        </b-col>
      </b-row>
      <span>Note: All the selected invoices will be updated with new information and you cannot undo this.</span>
    </b-modal>
    <b-modal
      id="salesapprove"
      size="sm"
      body-class="bg-white"
      cancel-title="Cancel"
      cancel-variant="light"
      ok-title="Yes"
      title="Bulk Approval-Quotations"
    >
      <p>Are you sure you want to approve the selected invoice(s)?</p>
    </b-modal>
    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'Quotation'"
      @downloaded="export_modal=false"
    />
    <!--  bulk delete modal -->
    <DeleteRecord
      v-on:setDelete="getDelete"
      :value="value"
      module="sales"
      content="The selected quotation(s) will be deleted and cannot be retrieved later. Are you sure about deleting them?"
    ></DeleteRecord>
    <LogRecord :message="logrecords"></LogRecord>
  </div>
 </div>
</template>
<script>
// import needed functions, file , components and state
import { mapState } from "vuex";
import store from "@/store/index"; // to call all vuex state
import moment from "moment"; // moment to declare the date fields
import RecordNotFound from "@/pages/Error/RecordNotFound";
import { notificationMixin } from "@/mixins/notification"; // notification is a global function to show notification success/error alert
import { formatDate } from "@/mixins/formatDate"; // to formatdate in y-m-d
import DeleteRecord from "@/components/Modal/DeleteModal"; // modal for deleting created credit used record
import LogRecord from "@/components/Modal/ErrorList"; // modal for deleting created credit used record
import $ from "jquery";
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll

function getPageSales(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1; // current page
  const show = parseInt(routeTo.query.show) || 10; // count per page
  const search = routeTo.query.search || ""; // search details
 const status = routeTo.query.status || store.state.sales.index_status || "";
  const label = routeTo.query.label || "";
  const custom = routeTo.query.custom || "";
  const sort = routeTo.query.sort || "";
  const from_date = routeTo.query.from_date || ""; // to show within date range
  const to_date = routeTo.query.to_date || ""; // to show within date range
  // get the list of data as per the requirements
  store
    .dispatch("sales/fetchLists", {
      page: currentPage,
      show: show,
      search: search,
      status: status,
      from_date: from_date,
      to_date: to_date,
      sort: sort,
      label: label,
      custom: custom
    })
    .then(response => {
      if (search != "" && response.status == 201) {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: response.data.status,
          type: "danger",
          showCloseButton: true
        });
      }
      else {
        store.dispatch("sales/fetchSalesDetails");
      }

      // store all the query details in route params
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.search = search;
      routeTo.params.status = status;
      routeTo.params.from_date = from_date;
      routeTo.params.to_date = to_date;
      routeTo.params.label = label;
      routeTo.params.sort = sort;
      routeTo.params.custom = custom;
      next();
    });
}
export default {
  mixins: [notificationMixin, formatDate, scrollTable], // register all your global function here to access as normal methods
  props: {
    // all your property
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },
    search: [String, Number],
    status: [String, Number],
    label: [String, Number],
    sort: [String, Number],
    custom: [String, Number],
    from_date: "",
    to_date: ""
  },
  name: "Sales", // name of the route
  components: {
    DeleteRecord,
    LogRecord,
    RecordNotFound
  },

  data() {
    return {
      arrow: false,
      export_data: [],
      export_modal: false,
      export_xl: {
        ID: "quot_no",
        Customer: "cus_name",
        "Sales Person": "sales_person_name",
        "Total Quantity": "total_qty",
        "Reference Number": "ref_no",
        "Quotation Date": "quot_created_date",
        "Expiry date": "quot_expiry_date",
        Status: "quot_status_name",
        "Total without Tax(BCY)": "total_without_tax",
        "Total without Tax(FCY)": "export_total_without_tax",
        "Total Tax(BCY)": "total_tax",
        "Total Tax(FCY)": "export_total_tax",
        "Adjusted amount(BCY)": "adjusted_amount",
        "Adjusted amount(FCY)": "export_adjusted_amount",
        "Total Discount amount(BCY)": "total_discount",
        "Total Discount amount(FCY)": "export_total_discount",
        "Total Price(BCY)": "total_value",
        "Total Price(FCY)": "export_total_value",
        "Created Time": "created_at",
        "Updated Time": "updated_at"
      },
      total_qty: "",
      sales_person_name: "",
      created_at: "",
      updated_at: "",
      ref_no: "",
      place_of_supply: "",
      quot_expiry_date: "",
      total_without_tax: "",
      total_tax: "",
      adjusted_amount: "",
      total_discount: "",
      logrecords: "", // to show log of popup funcitons
      value: [],

      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", // success alert notification class
      showDismissibleAlert: this.$route.query.search == "" ? false : true, // search criteria
      loading: true, // loader option
      total: 10, // total page to show
      email_id: "", // to send email to selected estimate
      checkboxes1: [],
      check_index: [],
      CheckedCount: 0
    };
  },
  updated() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  watch: {
    from_date() {
      if (
        this.$route.params.from_date == "" &&
        this.$route.params.to_date == ""
      ) {
        var child = this.$refs.daterangeupdate;
        child.checkConsole({
          startDate: this.$route.params.from_date,
          endDate: this.$route.params.to_date
        });
      }
    }
  },
  methods: {
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
    },
     changecode(){
      store.state.sales.status_code = "";
    },

    //refresh List
    getrefreshList() {
      var page = this.page;
      var page_show = this.show;
      const currentPage = page;
      const show = page_show;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const update = this.$route.query.update;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const from_date = this.$route.query.from_date || ""; // to show within date range
      const to_date = this.$route.query.to_date || ""; // to show within date range
      const custom = this.$route.query.custom || "";
      const update_status = update == true ? false : true;
      store
        .dispatch("sales/fetchLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          from_date: from_date,
          to_date: to_date,
          sort: sort,
          label: label,
          custom: custom
        })
        .then(() => {
          this.$router.push({
            name: this.$route.name,
            query: {
              from_date: from_date,
              to_date: to_date,
              page: currentPage,
              show: show,
              search: search,
              status: status,
              sort: sort,
              label: label,
              update: update_status
            }
          });
        });
    },
    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const custom = this.$route.query.custom || "";
      const from_date = this.$route.query.from_date || ""; // to show within date range
      const to_date = this.$route.query.to_date || ""; // to show within date range
      const response = await store
        .dispatch("sales/fetchexportLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          custom: custom,
          from_date: from_date,
          to_date: to_date
        })
       .then(() => {
               if(this.status_code!=200){
             window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.status_message,
            type: this.status_type,
            showCloseButton: true,
          });
          }else{
          this.$root.$emit("bv::show::modal", "exportdata");
          return this.export;
          }
        });
      return response;
    },
    startDownload() {
      this.loader = "Loading...";
    },
    finishDownload() {
      this.loader = "Downloaded";
    },
    //  detelted record details
    getDelete() {
      var page = this.page;
      var page_show = this.show;
      const currentPage = page;
      const show = page_show;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const update = this.$route.query.update;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const update_status = update == true ? false : true;
      store
        .dispatch("sales/fetchLists", {
          from_date: this.from_date,
          to_date: this.to_date,
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          update: update_status
        })
        .then(async () => {
          this.page = await (this.lists.length == 0 && this.page != 1
            ? (this.page = 1)
            : this.page);
          this.$route.params.sort = sort;
          this.$router.push({
            name: this.$route.name,
            query: {
              from_date: this.from_date,
              to_date: this.to_date,
              page: this.page,
              show: show,
              search: search,
              status: status,
              sort: sort,
              label: label,
              update: update_status
            }
          });
        });

       if (this.status_code == 200) {
      this.logrecords =
        this.message.message.length == 0
          ? this.message.success
          : this.message.message;
      this.$root.$emit("bv::show::modal", "loglist");
     }else {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.message.message,
            type: this.message.type,
            showCloseButton: true,
          });
        }
    },
    //  call delete modal
    deletemodal() {
      var ids = this.checkboxes1;
      ids = ids.filter(item => item !== false && item !== true);
      this.value = ids;
      this.$root.$emit("bv::show::modal", "invoicedelete");
    },
    checkAll(ev) {
      this.check_index = [];
      var fields = this;

      fields.lists.map(function(value, index) {
        fields.checkboxes1[index + 1] =
          ev.target.checked == true ? value.quot_hdr_id : false;
      });

      this.CheckedCount =
        ev.target.checked == true
          ? (this.page - 1) * this.show + this.lists.length
          : 0;
    },
    //select the checkbox//
    changeCheck(ev, checkbox, id) {
      var quot_hdr_ids = this.checkboxes1;
      quot_hdr_ids = quot_hdr_ids.filter(item => item !== false);
      // check all if page length matches
      if (quot_hdr_ids.length == this.lists.length) {
        this[checkbox][0] = true;
      }
      // uncheck if any of the checkbox is unchecked
      if (!ev.target.checked) {
        this[checkbox][0] = false;
      }
      if (this[checkbox][id] != false) {
        this.CheckedCount = parseInt(this.CheckedCount) + 1;
      } else {
        this.CheckedCount = parseInt(this.CheckedCount) - 1;
      }
    },
    // daterange picker updated method
    getDateRange(event) {
      this.from_date = event.startDate || "";
      this.to_date = event.endDate || "";
      if (!this.from_date && !this.to_date) {
        var child = this.$refs.daterangeupdate;
        child.checkConsole({
          startDate: this.from_date,
          endDate: this.to_date
        });
      }
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      this.$router.push({
        name: this.$route.name,
        query: {
          from_date: this.from_date,
          to_date: this.to_date,
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label
        }
      });
    },

    // to filter the json data - to get any particular data from json
    getPresentValue(arr, prop, val) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i]["filter_id"];
          break;
        }
      }
      return hasMatch;
    },
    // to convert the status from one to another
    changeStatus(status_id, quot_hdr_id) {
      this.loading = false;
      const currentPage = parseInt(this.$route.query.page) || 1; // current page
      const show = parseInt(this.$route.query.show) || 10; // count per page
      const search = this.$route.query.search || ""; // search details
      const status = this.$route.query.status || ""; // filter status
      const from_date =
        this.$route.query.from_date ||
        new Date(moment().startOf("month")).toLocaleDateString(); // to show within date range
      const to_date =
        this.$route.query.to_date ||
        new Date(moment().endOf("month")).toLocaleDateString(); // to show within date range
      // required data for api
      var id = JSON.stringify({
        status_id: status_id,
        quot_hdr_id: quot_hdr_id
      });
      // call the changestatus api to convert the status from one to another
      store.dispatch("sales/changeStatus", id).then(() => {
        // once again refresh the list after status has been changed
        store
          .dispatch("sales/fetchLists", {
            page: currentPage,
            show: show,
            search: search,
            status: status,
            from_date: from_date,
            to_date: to_date
          })
          .then(() => {
            this.loading = true;
            this.$route.params.page = currentPage;
            this.$route.params.show = show;
            this.$route.params.search = search;
            this.$route.params.status = status;
            this.$route.params.to_date = to_date;
            this.$route.params.from_date = from_date;
          });
      });
    },
    // sending email quotaion method
    handleEmail() {
      // call the mail sending api for selected customer and quotation
      store
        .dispatch("sales/sendEmail", {
          id: this.email_id // required data for sending email
        })
        .then(() => {
          // loop to show all the response list in order
          var message_list = [];
          for (var i = 0; i < this.email.Message.length; i++) {
            message_list.push("<li>" + this.email.Message[i] + "</li>");
          }
          var message = "<ul>" + message_list.join("") + "</ul>";
          // notification alert code to display the success or error message
          window.Messenger().post({
            message: message,
            extraClasses: this.locationClasses,
            type: "success",
            showCloseButton: true
          });
        });
    }
  },
  // called synchronously after the vue instance created
  created() {
    var check = [false];
    var i;
    for (i = 0; i < this.total; i++) {
      check.push(false);
    }
    this.checkboxes1 = check;
    this.CheckedCount = 0;
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
    // to get the messenger notification in pretty format
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
     store.state.sales.index_status=store.state.settings.status_code!=404? store.state.sales.index_status:""
     
    store.dispatch(
      "sales/fetchSalesDetails",
      JSON.stringify({
        type: "quotation",
        page: "filterdetails"
      })
    );
    getPageSales(routeTo, next); // function will be called before route enter ( to get all the api datas before page loading)
    store.dispatch("general/fetchQuotStatus"); // to update the state quotatin status dropdown before route enter
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
      store.state.sales.index_status = "";
    getPageSales(routeTo, next); // function will be called before route update ( to get all the api datas before page loading)
    this.CheckedCount = 0;
    this.checkboxes1 = [];
    this.check_index = [];
  },
    beforeRouteLeave(to, from, next) {
    store.state.sales.sales_index_history = from.fullPath;
    store.state.sales.index_status = from.params.status;
    store.state.settings.status_code=''
    next();
  },

  computed: {
    ...mapState({
      lists: state => state.sales.lists, // to show the data inside the table file: sales.js
      total_count: state => state.sales.total_count, // to show the total count of the data inside the table file: sales.js
      count: state => state.sales.count, // to show the  counts of the data inside the table file: sales.js
      search_criteria: state => state.sales.search_criteria, // to show the  search criteria name inside the table file: sales.js
      filter_list: state => state.sales.filter_list, // to show the  dropdown of filter list name inside the table file: sales.js
      filter_name: state => state.sales.filter_name, // to show the  name of the selected filter list name inside the table file: sales.js
      quot_status: state => state.general.quot_status, // to show the status of the quotation in dropdown
      email: state => state.sales.email, // to show email send quotation output
      is_no_records: state => state.sales.is_no_records, // to check for an record in the database
      message: state => state.sales.log_details,
      status_code: (state) => state.sales.status_code,
      status_message: (state) => state.sales.status_message,
      status_type: (state) => state.sales.status_type,
      export: state => state.sales.export
    })
  }
};
</script>
<style>
.btn-light.btn-sm {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.colors {
  color: #218bc3;
}
</style> 